import { createElement, useCallback, useMemo, useState } from 'react';
import type { ReactNode } from 'react';
import type { Command, GridMetadata } from '../../menu/types';
import { GridReactCommandHost } from './GridReactCommandHost';
import { findFirstSupportedGridReactCommand } from './registry';
import type { ActiveGridReactCommand, GridReactCommandRegistry } from './types';

type GridReactCommandActivation = {
  onRowActivate: ((row: Record<string, unknown>) => void) | undefined;
  activeRenderer: ReactNode;
};

export const useGridReactCommand = (
  commands: Command[] | undefined,
  metadata: GridMetadata,
  registry?: GridReactCommandRegistry
): GridReactCommandActivation => {
  const [activeCommand, setActiveCommand] = useState<ActiveGridReactCommand | null>(null);
  const supportedCommand = useMemo(
    () => findFirstSupportedGridReactCommand(commands, registry),
    [commands, registry]
  );

  const onRowActivate = useMemo(
    () =>
      supportedCommand
        ? (row: Record<string, unknown>) => {
            setActiveCommand({ command: supportedCommand, row });
          }
        : undefined,
    [supportedCommand]
  );
  const onClose = useCallback(() => setActiveCommand(null), []);

  return {
    onRowActivate,
    activeRenderer: createElement(GridReactCommandHost, {
      activeCommand,
      metadata,
      onClose,
      registry,
    }),
  };
};
